const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScootLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1149 238 47.582279 42",
    enableBackground: "new 1149 238 100 100",
    width: 475.82279,
    height: 420,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.66455696,0,0,0.66455696,373.12975,67.674051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1199.1,319.5 c 17.4,0 31.6,-14.1 31.6,-31.6 0,-17.4 -14.1,-31.6 -31.6,-31.6 -17.4,0 -31.6,14.1 -31.6,31.6 0,17.5 14.1,31.6 31.6,31.6",
    style: {
      fill: "#FFE900"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1229.1,286.3 1232.1,285.5 1234.5,295.3 1239.1,294.2 1239,291.5 1237.7,291.8 1235.9,284.6    1239.1,283.8 1238.3,280.2 1235.1,281 1234.1,277 1230.6,279.4 1231.2,281.9 1228.2,282.7 1229,286.3",
    style: {
      fill: "#1D1D1B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1228.6,283 c -1.2,-1.2 -2.9,-2 -5.1,-2 -4.8,0 -7.1,3.8 -7.1,7 l 0,0 c 0,3.2 2.3,7 7.1,7 4.8,0 7.1,-3.8 7.1,-7 0,-1.4 -0.4,-2.8 -1.2,-4 l -0.8,-1 z m -2,5 c 0,1.9 -1.4,3.3 -3.2,3.3 -1.7,0 -3.2,-1.4 -3.2,-3.3 l 0,0 c 0,-1.9 1.4,-3.3 3.2,-3.3 1.8,0 3.2,1.4 3.2,3.3 m -10.3,0 c 0,-3.2 -2.3,-7 -7.1,-7 -4.8,0 -7.1,3.8 -7.1,7 l 0,0 c 0,3.2 2.3,7 7.1,7 4.8,0 7.1,-3.8 7.1,-7 m -3.9,0 c 0,1.9 -1.4,3.3 -3.2,3.3 -1.7,0 -3.2,-1.4 -3.2,-3.3 l 0,0 c 0,-1.9 1.4,-3.3 3.2,-3.3 1.7,0 3.2,1.4 3.2,3.3 m -14.2,-1.5 4,0 c -0.7,-3.2 -3.5,-5.5 -7,-5.5 -3.9,0 -6.9,3.1 -6.9,7 0,3.9 3.1,7 7,7 3.6,0 6.2,-2.4 6.9,-5.4 l -4,0 c -0.4,0.8 -1.2,1.8 -2.8,1.8 -1.9,0 -3.1,-1.4 -3.1,-3.3 0,-0.9 0.3,-1.8 0.9,-2.4 0.6,-0.6 1.4,-1 2.3,-0.9 1.4,-0.2 2.2,0.8 2.7,1.7 m -14.1,-1.4 3.9,0 c -0.3,-3.5 -3.3,-4.1 -5.1,-4.1 -2.7,0 -5.1,1.7 -5.1,4.5 0,1.8 1.4,2.9 3.1,3.4 2.5,1 3.5,1.1 3.5,2 0,0.6 -0.7,1 -1.4,1 -0.2,0 -1.3,0 -1.5,-1.2 l -3.9,0 c 0.4,3.5 3.4,4.4 5.4,4.4 2.9,0 5.4,-1.7 5.4,-4.6 0,-2.8 -2.4,-3.5 -4.6,-4.1 -1,-0.3 -2,-0.7 -2,-1.3 0,-0.4 0.3,-0.9 1.1,-0.9 1.1,-0.1 1.2,0.6 1.2,0.9",
    style: {
      fill: "#1D1D1B"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScootLogo);
export default __webpack_public_path__ + "static/media/Scoot_logo.0be06b327f9400d68557db38704d07e4.svg";
export { ForwardRef as ReactComponent };